import InputFieldText from "Components/Common/InputFieldText";
import Modal from "Components/Common/Modal";
import { t } from "i18next";
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getImageUrl } from "utils";
import { Button, CircularProgress } from "@mui/material";
import { usePostNoticeGenerateMutation } from "apis/FireSafety/FireSafetyObservation";
import DocumentPreviewModal from "Components/Common/DocumentPreviewModal";

function GenarteNoticeModal({ setIsGenrateNoticeModal, scheduleId }) {
  const [noticePreview, setNoticePreview] = useState(null);

  const [getNotice, { isLoading: isGenrateNoticePdfLoading }] =
    usePostNoticeGenerateMutation();

  const formik = useFormik({
    initialValues: {
      referenceNumber: "",
    },
    validationSchema: Yup.object({
      referenceNumber: Yup.string().required("Reference Number is required"),
    }),
    onSubmit: async (values) => {
      try {
        const res = await getNotice(
          {
            isForPreview: true,
            scheduleId: scheduleId,
            referenceNumber: values.referenceNumber,
          },
          { showToast: false }
        );
        const pdfUrl = res?.data?.response;
        setNoticePreview({
          url: getImageUrl(pdfUrl),
          documentTypeName: "Generated Notice",
          documentType: "pdf",
          documentName: "GeneratedNotice",
        });
      } catch (error) {}
    },
  });
  const { values, handleSubmit, resetForm } = formik;

  const handleSave = async () => {
    try {
      await getNotice(
        {
          isForPreview: false,
          scheduleId: scheduleId,
          referenceNumber: values.referenceNumber,
        },
        { showToast: true }
      );
      setNoticePreview(null);
      setIsGenrateNoticeModal(null);
    } catch (error) {}
  };

  return (
    <>
      {!!noticePreview && (
        <DocumentPreviewModal
          isOpen
          handleClose={() => {
            setNoticePreview(null);
          }}
          actionButton={
            <Button
              color="primary"
              variant="contained"
              onClick={handleSave}
              disabled={isGenrateNoticePdfLoading}
            >
              {t("Save")}
              {isGenrateNoticePdfLoading && <CircularProgress size={20} />}
            </Button>
          }
          {...noticePreview}
        />
      )}

      <Modal
        isOpen
        handleClose={() => {
          resetForm();
          setIsGenrateNoticeModal(null);
        }}
        title="Reference Number"
        maxWidth="sm"
      >
        <form onSubmit={handleSubmit}>
          <div className="mt-3">
            <InputFieldText
              label={t("Reference Number") + "*"}
              name="referenceNumber"
              formik={formik}
              type="text"
              placeholder="Enter Reference Number"
            />

            <Button
              color="primary"
              variant="contained"
              type="submit"
              className="d-flex ms-auto gap-2 mt-3"
              disabled={isGenrateNoticePdfLoading}
            >
              {t("Submit")}
              {isGenrateNoticePdfLoading && <CircularProgress size={20} />}
            </Button>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default GenarteNoticeModal;
